export const removeMultipleWhitespaces = (string: string) =>
  string.replace(/\s\s+/g, ' ');

export const maskCredentials = (credential: string): string => {
  if (!credential?.length) {
    return credential;
  }

  const maskedPart =
    credential.length > 12
      ? credential.substring(4, credential.length - 4)
      : credential;
  const mask = '*'.repeat(Math.min(maskedPart.length, 32));
  return credential.replaceAll(maskedPart, mask);
};
